export default __webpack_public_path__ + "static/media/credit-card-thin.c20537bc.svg";